export default "__VITE_ASSET__L0hkKG21__"